import { ProductIDs } from './base';

export const OneBigSwitchIDs = {
  PowerHouseGas: 'obs-powerhousegas150-digital',
  SwitchSaver: 'obs-SWSdigital150',
} as const;

export type OneBigSwitchIDValues =
  (typeof OneBigSwitchIDs)[keyof typeof OneBigSwitchIDs];

// Excludes products that do not have a OBS promo
export type OneBigSwitchValidIDs = Extract<
  ProductIDs,
  typeof ProductIDs.GasPowerHouse | typeof ProductIDs.SwitchSaver
>;

export const OneBigSwitchPlanIDMapping: Record<
  OneBigSwitchValidIDs,
  OneBigSwitchIDValues | undefined
> = {
  [ProductIDs.SwitchSaver]: OneBigSwitchIDs.SwitchSaver,
  [ProductIDs.GasPowerHouse]: OneBigSwitchIDs.PowerHouseGas,
};
